export const RegionMockUXL = {
  search: {
    __typename: 'SearchQuery',
    properties: {
      __typename: 'SearchPropertiesQuery',
      searchByLocation: {
        __typename: 'PropertyDestinationSearchConnection',
        facets: [
          {
            __typename: 'PropertySearchFacet',
            buckets: [
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'africa',
                count: 1,
                label: 'Africa',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'asia',
                count: 1,
                label: 'Asia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'australia-pi',
                count: 1,
                label: 'Australia & Pacific Islands',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'canada',
                count: 1,
                label: 'Canada',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'caribbean',
                count: 1,
                label: 'Caribbean',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'central-america',
                count: 1,
                label: 'Central America',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'europe',
                count: 1,
                label: 'Europe',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'mexico',
                count: 1,
                label: 'Mexico',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'middle-east',
                count: 1,
                label: 'Middle East',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'south-america',
                count: 1,
                label: 'South America',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'united-states',
                count: 1,
                label: 'United States',
              },
            ],
            type: {
              __typename: 'PropertySearchFacetTypes',
              code: 'leisure-region',
              count: 1,
              enumCode: 'LEISURE_REGIONS',
              label: 'Leisure Region',
            },
          },
          {
            __typename: 'PropertySearchFacet',
            buckets: [
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AR',
                count: 1,
                label: 'AC Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AL',
                count: 1,
                label: 'Aloft Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BA',
                count: 1,
                label: 'Apartments by Marriott Bonvoy',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AK',
                count: 1,
                label: 'Autograph Collection',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'XE',
                count: 1,
                label: 'City Express by Marriott',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CY',
                count: 1,
                label: 'Courtyard',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DE',
                count: 1,
                label: 'Delta Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DS',
                count: 1,
                label: 'Design Hotels™',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'EB',
                count: 1,
                label: 'EDITION',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'EL',
                count: 1,
                label: 'Element Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'FI',
                count: 1,
                label: 'Fairfield Inn & Suites',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'FP',
                count: 1,
                label: 'Four Points by Sheraton',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'XF',
                count: 1,
                label: 'Four Points Express by Sheraton',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GE',
                count: 1,
                label: 'Gaylord Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'JW',
                count: 1,
                label: 'JW Marriott',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MD',
                count: 1,
                label: 'Le Méridien',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ER',
                count: 1,
                label: 'Marriott Executive Apartments',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MC',
                count: 1,
                label: 'Marriott Hotels & Resorts',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MV',
                count: 1,
                label: 'Marriott Vacation Club',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MG',
                count: 1,
                label: 'MGM Collection with Marriott Bonvoy',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'OX',
                count: 1,
                label: 'Moxy Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PR',
                count: 1,
                label: 'Protea Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BR',
                count: 1,
                label: 'Renaissance Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'RI',
                count: 1,
                label: 'Residence Inn',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SI',
                count: 1,
                label: 'Sheraton',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SH',
                count: 1,
                label: 'SpringHill Suites',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'XR',
                count: 1,
                label: 'St. Regis',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'LC',
                count: 1,
                label: 'The Luxury Collection',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'RZ',
                count: 1,
                label: 'The Ritz-Carlton',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TS',
                count: 1,
                label: 'TownePlace Suites',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TX',
                count: 1,
                label: 'Tribute Portfolio',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'WH',
                count: 1,
                label: 'W Hotels',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'WI',
                count: 1,
                label: 'Westin Hotels & Resorts',
              },
            ],
            type: {
              __typename: 'PropertySearchFacetTypes',
              code: 'brands',
              count: 1,
              enumCode: 'BRANDS',
              label: 'Brands',
            },
          },
          {
            __typename: 'PropertySearchFacet',
            buckets: [
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: "Ivory Coast (Cote D'Ivoire)",
                count: 1,
                label: null,
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'Moldova',
                count: 1,
                label: null,
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AL',
                count: 1,
                label: 'Albania',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DZ',
                count: 1,
                label: 'Algeria',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AO',
                count: 1,
                label: 'Angola',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AQ',
                count: 1,
                label: 'Antarctica',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AG',
                count: 1,
                label: 'Antigua and Barbuda',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AR',
                count: 1,
                label: 'Argentina',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AM',
                count: 1,
                label: 'Armenia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AW',
                count: 1,
                label: 'Aruba',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AU',
                count: 1,
                label: 'Australia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AT',
                count: 1,
                label: 'Austria',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AZ',
                count: 1,
                label: 'Azerbaijan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BS',
                count: 1,
                label: 'Bahamas',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BH',
                count: 1,
                label: 'Bahrain',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BD',
                count: 1,
                label: 'Bangladesh',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BB',
                count: 1,
                label: 'Barbados',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BY',
                count: 1,
                label: 'Belarus',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BE',
                count: 1,
                label: 'Belgium',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BZ',
                count: 1,
                label: 'Belize',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BM',
                count: 1,
                label: 'Bermuda',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BT',
                count: 1,
                label: 'Bhutan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BO',
                count: 1,
                label: 'Bolivia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BA',
                count: 1,
                label: 'Bosnia and Herzegovina',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BW',
                count: 1,
                label: 'Botswana',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BR',
                count: 1,
                label: 'Brazil',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'BG',
                count: 1,
                label: 'Bulgaria',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KH',
                count: 1,
                label: 'Cambodia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CA',
                count: 1,
                label: 'Canada',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KY',
                count: 1,
                label: 'Cayman Islands',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CL',
                count: 1,
                label: 'Chile',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CN',
                count: 1,
                label: 'China',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CO',
                count: 1,
                label: 'Colombia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CR',
                count: 1,
                label: 'Costa Rica',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'HR',
                count: 1,
                label: 'Croatia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CW',
                count: 1,
                label: 'Curacao',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CY',
                count: 1,
                label: 'Cyprus',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CZ',
                count: 1,
                label: 'Czech Republic',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DK',
                count: 1,
                label: 'Denmark',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DJ',
                count: 1,
                label: 'Djibouti',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DO',
                count: 1,
                label: 'Dominican Republic',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'EC',
                count: 1,
                label: 'Ecuador',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'EG',
                count: 1,
                label: 'Egypt',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SV',
                count: 1,
                label: 'El Salvador',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'EE',
                count: 1,
                label: 'Estonia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ET',
                count: 1,
                label: 'Ethiopia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'FJ',
                count: 1,
                label: 'Fiji',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'FI',
                count: 1,
                label: 'Finland',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'FR',
                count: 1,
                label: 'France',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PF',
                count: 1,
                label: 'French Polynesia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GE',
                count: 1,
                label: 'Georgia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DE',
                count: 1,
                label: 'Germany',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GH',
                count: 1,
                label: 'Ghana',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GR',
                count: 1,
                label: 'Greece',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GD',
                count: 1,
                label: 'Grenada',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GU',
                count: 1,
                label: 'Guam',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GT',
                count: 1,
                label: 'Guatemala',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GY',
                count: 1,
                label: 'Guyana',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'HT',
                count: 1,
                label: 'Haiti',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'HN',
                count: 1,
                label: 'Honduras',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'HK',
                count: 1,
                label: 'Hong Kong',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'HU',
                count: 1,
                label: 'Hungary',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'IS',
                count: 1,
                label: 'Iceland',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'IN',
                count: 1,
                label: 'India',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ID',
                count: 1,
                label: 'Indonesia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'IE',
                count: 1,
                label: 'Ireland',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'IL',
                count: 1,
                label: 'Israel',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'IT',
                count: 1,
                label: 'Italy',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'JM',
                count: 1,
                label: 'Jamaica',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'JP',
                count: 1,
                label: 'Japan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'JO',
                count: 1,
                label: 'Jordan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KZ',
                count: 1,
                label: 'Kazakhstan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KE',
                count: 1,
                label: 'Kenya',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'XK',
                count: 1,
                label: 'Kosovo',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KW',
                count: 1,
                label: 'Kuwait',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KG',
                count: 1,
                label: 'Kyrgyzstan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'LV',
                count: 1,
                label: 'Latvia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'LB',
                count: 1,
                label: 'Lebanon',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'LT',
                count: 1,
                label: 'Lithuania',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'LU',
                count: 1,
                label: 'Luxembourg',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MO',
                count: 1,
                label: 'Macau',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MK',
                count: 1,
                label: 'Macedonia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MW',
                count: 1,
                label: 'Malawi',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MY',
                count: 1,
                label: 'Malaysia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MV',
                count: 1,
                label: 'Maldives',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MT',
                count: 1,
                label: 'Malta',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MU',
                count: 1,
                label: 'Mauritius',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MX',
                count: 1,
                label: 'Mexico',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MC',
                count: 1,
                label: 'Monaco',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ME',
                count: 1,
                label: 'Montenegro',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MA',
                count: 1,
                label: 'Morocco',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NA',
                count: 1,
                label: 'Namibia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NP',
                count: 1,
                label: 'Nepal',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NL',
                count: 1,
                label: 'Netherlands',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NC',
                count: 1,
                label: 'New Caledonia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NZ',
                count: 1,
                label: 'New Zealand',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NG',
                count: 1,
                label: 'Nigeria',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NO',
                count: 1,
                label: 'Norway',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'OM',
                count: 1,
                label: 'Oman',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PK',
                count: 1,
                label: 'Pakistan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PA',
                count: 1,
                label: 'Panama',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PG',
                count: 1,
                label: 'Papua New Guinea',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PY',
                count: 1,
                label: 'Paraguay',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PE',
                count: 1,
                label: 'Peru',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PH',
                count: 1,
                label: 'Philippines',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PL',
                count: 1,
                label: 'Poland',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PT',
                count: 1,
                label: 'Portugal',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PR',
                count: 1,
                label: 'Puerto Rico',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'QA',
                count: 1,
                label: 'Qatar',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'RO',
                count: 1,
                label: 'Romania',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'RW',
                count: 1,
                label: 'Rwanda',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KN',
                count: 1,
                label: 'Saint Kitts and Nevis',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'LC',
                count: 1,
                label: 'Saint Lucia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'WS',
                count: 1,
                label: 'Samoa',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SA',
                count: 1,
                label: 'Saudi Arabia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SN',
                count: 1,
                label: 'Senegal',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'RS',
                count: 1,
                label: 'Serbia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SC',
                count: 1,
                label: 'Seychelles',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SG',
                count: 1,
                label: 'Singapore',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SX',
                count: 1,
                label: 'Sint Maarten',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SK',
                count: 1,
                label: 'Slovak Republic',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SI',
                count: 1,
                label: 'Slovenia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ZA',
                count: 1,
                label: 'South Africa',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KR',
                count: 1,
                label: 'South Korea',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ES',
                count: 1,
                label: 'Spain',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'LK',
                count: 1,
                label: 'Sri Lanka',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SR',
                count: 1,
                label: 'Suriname',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SE',
                count: 1,
                label: 'Sweden',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CH',
                count: 1,
                label: 'Switzerland',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TW',
                count: 1,
                label: 'Taiwan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TH',
                count: 1,
                label: 'Thailand',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TT',
                count: 1,
                label: 'Trinidad and Tobago',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TN',
                count: 1,
                label: 'Tunisia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TC',
                count: 1,
                label: 'Turks and Caicos Islands',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TR',
                count: 1,
                label: 'Türkiye',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'UG',
                count: 1,
                label: 'Uganda',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AE',
                count: 1,
                label: 'United Arab Emirates',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GB',
                count: 1,
                label: 'United Kingdom',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TZ',
                count: 1,
                label: 'United Republic of Tanzania',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'UY',
                count: 1,
                label: 'Uruguay',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'US',
                count: 1,
                label: 'USA',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'UZ',
                count: 1,
                label: 'Uzbekistan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'VE',
                count: 1,
                label: 'Venezuela',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'VN',
                count: 1,
                label: 'Vietnam',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'VI',
                count: 1,
                label: 'Virgin Islands (US)',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ZM',
                count: 1,
                label: 'Zambia',
              },
            ],
            type: {
              __typename: 'PropertySearchFacetTypes',
              code: 'countries',
              count: 1,
              enumCode: 'COUNTRIES',
              label: 'Countries / Regions',
            },
          },

          {
            __typename: 'PropertySearchFacet',
            buckets: [
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AL',
                count: 1,
                label: 'Alabama',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AK',
                count: 1,
                label: 'Alaska',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AZ',
                count: 1,
                label: 'Arizona',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'AR',
                count: 1,
                label: 'Arkansas',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CA',
                count: 1,
                label: 'California',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CO',
                count: 1,
                label: 'Colorado',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'CT',
                count: 1,
                label: 'Connecticut',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DE',
                count: 1,
                label: 'Delaware',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'DC',
                count: 1,
                label: 'District Of Columbia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'FL',
                count: 1,
                label: 'Florida',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'GA',
                count: 1,
                label: 'Georgia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'HI',
                count: 1,
                label: 'Hawaii',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ID',
                count: 1,
                label: 'Idaho',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'IL',
                count: 1,
                label: 'Illinois',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'IN',
                count: 1,
                label: 'Indiana',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'IA',
                count: 1,
                label: 'Iowa',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KS',
                count: 1,
                label: 'Kansas',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'KY',
                count: 1,
                label: 'Kentucky',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'LA',
                count: 1,
                label: 'Louisiana',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ME',
                count: 1,
                label: 'Maine',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MD',
                count: 1,
                label: 'Maryland',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MA',
                count: 1,
                label: 'Massachusetts',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MI',
                count: 1,
                label: 'Michigan',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MN',
                count: 1,
                label: 'Minnesota',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MS',
                count: 1,
                label: 'Mississippi',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MO',
                count: 1,
                label: 'Missouri',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'MT',
                count: 1,
                label: 'Montana',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NE',
                count: 1,
                label: 'Nebraska',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NV',
                count: 1,
                label: 'Nevada',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NH',
                count: 1,
                label: 'New Hampshire',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NJ',
                count: 1,
                label: 'New Jersey',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NM',
                count: 1,
                label: 'New Mexico',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NY',
                count: 1,
                label: 'New York',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'NC',
                count: 1,
                label: 'North Carolina',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'ND',
                count: 1,
                label: 'North Dakota',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'OH',
                count: 1,
                label: 'Ohio',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'OK',
                count: 1,
                label: 'Oklahoma',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'OR',
                count: 1,
                label: 'Oregon',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'PA',
                count: 1,
                label: 'Pennsylvania',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'RI',
                count: 1,
                label: 'Rhode Island',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SC',
                count: 1,
                label: 'South Carolina',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'SD',
                count: 1,
                label: 'South Dakota',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TN',
                count: 1,
                label: 'Tennessee',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'TX',
                count: 1,
                label: 'Texas',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'UT',
                count: 1,
                label: 'Utah',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'VT',
                count: 1,
                label: 'Vermont',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'VA',
                count: 1,
                label: 'Virginia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'WA',
                count: 1,
                label: 'Washington',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'WV',
                count: 1,
                label: 'West Virginia',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'WI',
                count: 1,
                label: 'Wisconsin',
              },
              {
                __typename: 'PropertySearchTermFacetBucket',
                code: 'WY',
                count: 1,
                label: 'Wyoming',
              },
            ],
            type: {
              __typename: 'PropertySearchFacetTypes',
              code: 'states',
              count: 1,
              enumCode: 'STATES',
              label: 'States / Provinces',
            },
          },
        ],
        total: 1,
      },
    },
  },
};
